module.exports = __webpack_public_path__ + "images/carousel-arrow-next.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/carousel-arrow-next.png
// module id = 846
// module chunks = 0